import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateCompanyRoleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ params }) => {
      const response = await axios.post('/company_roles', {
        company_role: params,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['assignableCompanyRoles']);
      queryClient.invalidateQueries(['companyRoles']);
    },
  });
}

export function useUpdateCompanyRoleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, params }) => {
      const response = await axios.patch(`/company_roles/${id}`, {
        company_role: params,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['assignableCompanyRoles']);
      queryClient.invalidateQueries(['companyRoles']);
    },
  });
}

export function useDestroyCompanyRoleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/company_roles/${id}`);
      return response.data;
    },
    onSuccess: async (_result, variables) => {
      await queryClient.cancelQueries({
        queryKey: ['companyRoles', variables.id],
      });

      queryClient.invalidateQueries(['assignableCompanyRoles']);

      queryClient.invalidateQueries({
        queryKey: ['companyRoles'],
        predicate: ({ queryKey }) => queryKey[1] !== variables.id,
      });
    },
  });
}
